"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCopy(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { d: "M15 8c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H6c-.552 0-1-.384-1-.857V8.857C5 8.384 5.448 8 6 8h9zm-1 2H7v8h7v-8zm5-6c.552 0 1 .416 1 .929V15.07c0 .513-.448.929-1 .929h-1V6H9V4.929C9 4.416 9.448 4 10 4h9z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Copy')(SvgCopy);
//# sourceMappingURL=Copy.js.map